'use strict';

module.exports = {
    Constants: {

        BackFileDataSeparator: '<html>',
        BackfileCustomerTrn: '__BACKFILE__CUSTOMER__TRN',
        BackfileCustomerAccountNumber: '__BACKFILE__CUSTOMER__ACCOUNTNUMBER',
        BackfileCustomerAccountOpeningTime: '__BACKFILE__CUSTOMER__ACCOUNTOPENINGTIME',
        BackfileCustomerOin: '__BACKFILE__CUSTOMER__OIN',
        BackfileAdviser: '__BACKFILE__ADVISER__ADVISERNAME',
        BackfileDealerId: '__BACKFILE__ADVISER__DEALERID',
        BackfileAdviserId: '__BACKFILE__ADVISER__ADVISERID',
        BackfileAdviserDateVerification: '__BACKFILE__ADVISER__DATEOFVERIFICATION',

        FilenoteProduct: '__FILENOTE__PRODUCT__',
        FilenoteDateOfBirth: '__FILENOTE__DOB__',
        FilenoteDateOfBirthField: '__FILENOTE__DOBFIELD__',
        FilenoteAccountNumber: '__FILENOTE__ACCOUNTNUMBER__',
        FilenoteOin: '__FILENOTE__OIN__',
        FilenoteName: '__FILENOTE__NAME__',
        FilenoteDateOfApp: '__FILENOTE__DATEOFAPP__'
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/WorkItemConstants.js